import BackSteelBlack from "../images/customisation-assets/Back_Steel_Black.png";
import BackSteelSilver from "../images/customisation-assets/Back_Steel_Silver.png";
import BackTitanium from "../images/customisation-assets/Back_Titanium.png";

export const BACK_IMAGE_OPTIONS = {
  steelBlack: {
    title: "Steel Black",
    watchLayerAsset: BackSteelBlack,
  },
  steelSilver: {
    title: "Steel",
    watchLayerAsset: BackSteelSilver,
  },
  titanium: {
    title: "Titanium",
    watchLayerAsset: BackTitanium,
  },
};
